import { defineMessages } from 'react-intl';

export default defineMessages({
  migrateAccountConfirmationTitle: {
    id: 'migrate.account.confirmation.title',
    defaultMessage: "We've migrated your account!",
    description: 'Page heading',
  },
  migrateAccountConfirmationButtonText: {
    id: 'migrate.account.confirmation.button.text',
    defaultMessage: 'Continue to {productDisplayName}',
    description: 'Button text',
  },
  migrateAccountConfirmationSummaryText: {
    id: 'migrate.account.confirmation.summary.text',
    defaultMessage:
      'Your {productDisplayName} password has expired. ' +
      'From now on, use your Atlassian account to access {productDisplayName}.',
    description: 'Summary text',
  },
  headTitle: {
    id: 'migrate.account.confirmation.head.title',
    defaultMessage: 'Confirmed',
  },
});
